import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { hideImageModal } from '../../actions/image';

import './ImageModal.css';

class ImageModal extends React.Component {
  static propTypes = {
    // Redux State.
    imageModal: PropTypes.string,

    // Redux Dispatch.
    hideImageModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    imageModal: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      show: props.imageModal !== null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.imageModal !== null,
    });
  }

  onExited = () => {
    this.props.hideImageModal();
  };

  onHide = () => {
    this.setState({ show: false });
  };

  render() {
    const { show } = this.state;
    const { imageModal } = this.props;

    return (
      <Modal
        dialogClassName="image-modal"
        onExited={this.onExited}
        onHide={this.onHide}
        show={show}
      >
        <Modal.Body>
          <div className="content-wrapper">
            <div className="content">
              <img className="img-rounded" src={imageModal} alt="" onClick={this.onHide} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { imageModal } = state;
  return {
    imageModal,
  };
};

const mapDispatchToProps = {
  hideImageModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageModal);



// WEBPACK FOOTER //
// ./src/containers/ImageModal/index.js